module.exports = __webpack_public_path__ + "static/media/undraw_next_tasks_iubr.0a4804c9.png";